import { z } from "zod";

export const UpdateRoomTypeSchema = z.object({
    name: z.string().nonempty('Room type name is required'),
    description: z.string().optional(),
    occ_adults: z.coerce.number().int().min(1, 'Adults number must be greater than 0'),
    occ_children: z.coerce.number().int().min(0, 'Children number must be 0 or greater'),
});